import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInterruptions from './interruptions.reducer';

const getInterruptionsFeatureState = createFeatureSelector<fromInterruptions.InterruptionsState>('interruptions');

export const selectAreInterruptionsReady = createSelector(getInterruptionsFeatureState, state => state.interruptionsAreReady);

export const selectLocalTimeOffset = createSelector(
  getInterruptionsFeatureState,
  (state: fromInterruptions.InterruptionsState) => state && state.localTimeOffset,
);

export const selectTimezoneOffset = createSelector(
  getInterruptionsFeatureState,
  (state: fromInterruptions.InterruptionsState) => state && state.timezoneOffset,
);

export const selectPrayerTimeInterruptions = createSelector(
  getInterruptionsFeatureState,
  (state: fromInterruptions.InterruptionsState) => state && state.prayerTimeInterruptions,
);

export const selectPrayerTimeAudioSource = createSelector(getInterruptionsFeatureState, state => state && state.prayerTimeAudioSource);

export const selectAdInterruptions = createSelector(getInterruptionsFeatureState, state => state && state.adInterruptions);

export const selectNextPrayerTimeInterruptionDate = createSelector(
  getInterruptionsFeatureState,
  (state: fromInterruptions.InterruptionsState) =>
    state && state.nextPrayerTimeInterruption && state.nextPrayerTimeInterruption.beforeSilenceStart,
);

export const selectPreviousMutedState = createSelector(getInterruptionsFeatureState, state => state.previousMutedState);
